export enum ReviewStatus {
  Approved = "approved",
  Denied = "denied",
}
